import { render, staticRenderFns } from "./gj-add-select.vue?vue&type=template&id=4a76c895&scoped=true&"
import script from "./gj-add-select.vue?vue&type=script&lang=js&"
export * from "./gj-add-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-add-select.vue?vue&type=style&index=0&id=4a76c895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a76c895",
  null
  
)

export default component.exports